import { render, staticRenderFns } from "./pointslist.vue?vue&type=template&id=5908698f&scoped=true"
import script from "./pointslist.vue?vue&type=script&lang=js"
export * from "./pointslist.vue?vue&type=script&lang=js"
import style0 from "./pointslist.vue?vue&type=style&index=0&id=5908698f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908698f",
  null
  
)

export default component.exports